import { LoadingButton } from '@mui/lab'
import { LoginContext } from '../context'
import { Stack, Alert } from '@mui/material'
import { useContextSelector } from 'use-context-selector'
import { FormInputText } from '@andreciornavei/mui-boost'
import { useForm } from 'react-hook-form'
import { CredentialsType } from '@type/creentials_type'

export const LoginFormContainer = (): JSX.Element => {
  const error = useContextSelector(LoginContext, (s) => s.error)
  const loading = useContextSelector(LoginContext, (s) => s.loading)
  const handleSubmitForm = useContextSelector(
    LoginContext,
    (s) => s.handleSubmit
  )

  const { handleSubmit, control } = useForm<Partial<CredentialsType>>({
    defaultValues: {
      email: '',
      password: '',
    },
  })

  return (
    <form onSubmit={handleSubmit(handleSubmitForm)}>
      <Stack direction="column" spacing={2}>
        {error?.message && <Alert severity="error">{error.message}</Alert>}
        <FormInputText
          name="email"
          control={control}
          label="Seu melhor email"
          disabled={loading}
          error={error?.errors?.email}
        />
        <FormInputText
          name="password"
          type="password"
          control={control}
          disabled={loading}
          label="Senha super secreta"
          error={error?.errors?.password}
          helper={'Deve possuir ao menos 16 caracteres.'}
        />
        <LoadingButton type="submit" variant="contained" loading={loading}>
          Acessar a plataforma
        </LoadingButton>
      </Stack>
    </form>
  )
}
